import { render } from "./EnResumenView.vue?vue&type=template&id=386e1fc0"
import script from "./EnResumenView.vue?vue&type=script&lang=js"
export * from "./EnResumenView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__